<template>
  <!-- eslint-disable vue/no-v-html -->
  <!-- nosemgrep: javascript.vue.security.audit.xss.templates.avoid-v-html.avoid-v-html -->
  <span v-html="finalRender" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { type TextColor, colorClasses } from '../text-color'

import { extractColorTextPairs } from './MarkStyles.helpers'

const props = defineProps<{ text: string }>()

const finalRender = computed(() => {
  const matches = [...extractColorTextPairs(props.text)]
  if (!matches.length) return props.text

  let finalText = props.text
  for (let i = 0; i < matches.length; i += 1) {
    const color = matches[i].color as TextColor
    const { text } = matches[i]

    if (!colorClasses[color]) continue

    finalText = finalText.replace(
      `[${color}](${text})`,
      `<span class="${colorClasses[color]}">${text}</span>`,
    )
  }

  return finalText
})
</script>
